import http from "../../http";
export default {
  tree: params => {
    return http.get("activityservice/collaboration/tree", params);
  },
  list: params => {
    return http.get("activityservice/collaboration/listAll", params);
  },
  save: params => {
    return http.post("activityservice/collaboration/saveAll", params);
  },
  del: params => {
    return http.post("activityservice/collaboration/delete", params);
  },
  report: params => {
    return http.get("activityservice/statistics/collstat/get", params)
  }
};
